import isMacintosh from "@/helpers/checkMacintosh"

export enum KeyType {
  ITEM = "ITEM",
  PROJECT = "PROJECT",
  GOAL = "GOAL",
  MILESTONE = "MILESTONE",
  EPIC = "EPIC",
  SPRINT = "SPRINT",
  IDEA = "IDEA"
}

export const keys = (type: KeyType): string => {
  const letter = type === KeyType.IDEA ? "D" : ([...type][0] ?? "Undefined")

  return isMacintosh() ? `⌘+⇧+${letter}` : `Ctrl+Shift+${letter}`
}
